import { chakra } from '@chakra-ui/react'
import { NFT } from './NFT'

export const ChakraNFT = chakra(NFT);